import React from "react";
import {
  Dialog,
  Flex,
  Text,
  Divider,
  Checkbox,
  Loader,
} from "@fluentui/react-northstar";
import { useTranslation } from "react-i18next";
import "./NotificationSettingsDialog.scss";

const NotificationSettingsDialog = ({
  open,
  onCancel,
  onSave,
  notificationSettings,
  handleCheckboxChange,
  notificationOptions,
  networkType,
  isLoading,
}) => {
  const { t } = useTranslation();
  const translation = t("trustedNetwork").notificationSettingsDialog;

  return (
    <Dialog
      open={open}
      onCancel={onCancel}
      header={`Manage Notifications for ${networkType} Network`}
      confirmButton={{
        content: translation.save,
        primary: true,
        disabled: isLoading,
        loading: isLoading,
        onClick: onSave,
      }}
      cancelButton={{
        content: translation.cancel,
        disabled: isLoading,
        onClick: onCancel,
      }}
      className="notification-settings-dialog"
      styles={{ width: "500px", marginBottom: "10px" }}
      content={
        <>
          <Text
            content={translation.disclaimerText}
            style={{
              color: "#b26a00",
              background: "#fffbe6",
              padding: "8px 12px",
              borderRadius: "4px",
              marginBottom: "12px",
              display: "block",
              fontSize: "13px",
            }}
          />
          <Text
            content={translation.selectNotifications.replace(
              "{{networkType}}",
              networkType
            )}
            color="grey"
            size="small"
          />
          <Divider styles={{ margin: "10px 0" }} size={2} />
          <Flex column gap="gap.medium">
            <Flex gap="gap.medium" vAlign="center">
              <Text
                content="Notifications"
                style={{ width: "50%", fontWeight: "bold" }}
              />
              <Text
                content="ACV"
                style={{
                  width: "25%",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Text
                content="Email"
                style={{
                  width: "25%",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
            </Flex>
            {notificationOptions.map((option) => (
              <Flex
                key={option.key}
                gap="gap.medium"
                vAlign="center"
                justifyContent="center"
              >
                <Text content={option.label} style={{ width: "50%" }} />
                <Flex style={{ width: "25%", justifyContent: "center" }}>
                  <Checkbox
                    checked={notificationSettings[`${option.key}ACV`]}
                    onChange={() => handleCheckboxChange(`${option.key}ACV`)}
                    disabled={isLoading}
                  />
                </Flex>
                <Flex style={{ width: "25%", justifyContent: "center" }}>
                  <Checkbox
                    checked={notificationSettings[`${option.key}Email`]}
                    onChange={() => handleCheckboxChange(`${option.key}Email`)}
                    disabled={isLoading}
                  />
                </Flex>
              </Flex>
            ))}
          </Flex>
        </>
      }
    />
  );
};

export default NotificationSettingsDialog;
